const NewsSingle = () => {
    return(
        <h1>NewsSingle</h1>
    );
}

export default NewsSingle;